// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.handler

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.RpcAuthException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.rpc.handler.RpcAuthError

fun RpcAuthException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Eft1lVgdH-Qsjk5LriTMRXDVR-P0eSa1K4nxk01mzzo")
val RpcAuthException_cborSchemaId = ByteString(17, -5, 117, -107, 88, 29, 31, -28, 44, -114, 78, 75, -82, 36, -52, 69, 112, -43, 71, -29, -12, 121, 38, -75, 43, -119, -15, -109, 77, 102, -49, 58)

fun RpcAuthException.Companion.fromCbor(data: ByteArray): RpcAuthException {
    return RpcAuthException.fromDataItem(Cbor.decode(data))
}

val RpcAuthException.Companion.cborSchemaId: ByteString
    get() = RpcAuthException_cborSchemaId

fun RpcAuthException.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val message = this.message
    if (message != null) {
        builder.put("message", Tstr(message))
    }
    builder.put("rpcAuthError", Tstr(this.rpcAuthError.name))
    return builder.end().build()
}

fun RpcAuthException.Companion.fromDataItem(dataItem: DataItem): RpcAuthException {
    val message0 = if (dataItem.hasKey("message")) {
        dataItem["message"].asTstr
    } else {
        null
    }
    val rpcAuthError = RpcAuthError.valueOf(dataItem["rpcAuthError"].asTstr)
    return RpcAuthException(
        message = message0,
        rpcAuthError = rpcAuthError,
    )
}
